import { createContext, useContext } from 'react';
import WhiteCard from './WhiteCard';
import Heading from './Heading';
import Button from './Button';
import Modal from './Modal';
import Loader from './Loader';
import LoaderText from './LoaderText';
import ButtonNew from './ButtonNew';

const TableContext = createContext();
function Table({
    children,
    cols = 'grid-cols-tableLists',
    className = '',
    whiteCardClassName = '',
    minHeight = 'min-h-[70vh]',
    bg = 'bg-grayBgNormal',
}) {
    return (
        <TableContext.Provider value={{ cols, className }}>
            <WhiteCard
                bg={bg}
                className={`p-6 ${whiteCardClassName}  ${minHeight}  overflow-x-hidden overflow-y-auto main `}
            >
                {children}
            </WhiteCard>
        </TableContext.Provider>
    );
}

function TableDescription({
    description = '',
    secondaryBtn = '',
    primaryBtn = '',
    tertiaryBtn = '',
    clickOnPrimary,
    clickOnSecondary,
    children,
    descriptionClass = '',
    clickOnTertiary,
    primaryBtnModal = '',
    primaryBtnBlueModal = '',
    primaryBtnBlueModal2 = '',
    modalNeedToOpen,
    loadingText = '',
    loading,
    isLoaderApply = false,
}) {
    if (!description) return null;
    return (
        <div className={`flex mb-5 justify-between ${descriptionClass}  `}>
            <Heading className={`text-textPrimary font-medium  `} type={'large'}>
                {description}
            </Heading>
            <div className="flex divide-x divide-solid divide-borderUnderline ">
                {children}
                {tertiaryBtn && (
                    
                    <ButtonNew   onClick={clickOnTertiary} variant="transparent" size="sm">
                   {tertiaryBtn}
                    </ButtonNew>
                )}

                {secondaryBtn && (
                  
                     <ButtonNew   onClick={clickOnSecondary} variant="transparent" size="sm">
                     {secondaryBtn}
                      </ButtonNew>
                )}
                {primaryBtn &&
                    (isLoaderApply ? (
                        <ButtonNew variant="blue"
                        size="sm"  disabled={loading} onClick={clickOnPrimary} >
                            {loading ? <Loader /> : primaryBtn}
                        </ButtonNew>
                    ) : (
                      
                         <ButtonNew
                         onClick={clickOnPrimary}
                         variant="blue"
                         size="sm"  >
                          {primaryBtn}
                     </ButtonNew>
                    ))}
                {primaryBtnModal && (
                    <Modal>
                        <Modal.Button className="flex gap-2 cursor-pointer items-center" opens={primaryBtnModal}>
                           
                            <ButtonNew    variant="transparent" size="sm">
                            {primaryBtnModal}
                      </ButtonNew>
                        </Modal.Button>
                        <Modal.Window name={primaryBtnModal}>{modalNeedToOpen}</Modal.Window>
                    </Modal>
                )}
                {primaryBtnBlueModal && (
                    <Modal>
                        <Modal.Button className="flex gap-2 cursor-pointer items-center" opens={primaryBtnBlueModal}>
                            
                            <ButtonNew
                                variant="blue"
                                size="sm"  >
                               {primaryBtnBlueModal}
                            </ButtonNew>
                        </Modal.Button>
                        <Modal.Window name={primaryBtnBlueModal}>{modalNeedToOpen}</Modal.Window>
                    </Modal>
                )}
                {primaryBtnBlueModal2 && (
                    <Modal>
                        <Modal.Button className="flex gap-2 cursor-pointer items-center" opens={primaryBtnBlueModal2}>
                            {isLoaderApply ? (
                                loading ? (
                                    <Button
                                        disabled={loading}
                                        size="xsmall"
                                        className={`${loading ? 'cursor-not-allowed' : ' cursor-pointer'}`}
                                    >
                                        {/* <div className="p-6 bg-gray-50 rounded-xl"> */}
                                        <LoaderText text={loadingText} size="sm" color="white" />
                                        {/* </div> */}
                                    </Button>
                                ) : (
                                    <Button
                                        disabled={loading}
                                        size="xsmall"
                                        className={`${loading ? 'cursor-not-allowed' : ' cursor-pointer'}`}
                                    >
                                        {primaryBtnBlueModal2}
                                    </Button>
                                )
                            ) : (
                                <Button size="xsmall">{primaryBtnBlueModal2}</Button>
                            )}
                        </Modal.Button>
                        <Modal.Window name={primaryBtnBlueModal2}>{modalNeedToOpen}</Modal.Window>
                    </Modal>
                )}
            </div>
        </div>
    );
}

function TableHeader({ children, isBorder = true, headerClassName = 'py-3' }) {
    const { cols, className } = useContext(TableContext);

    return (
        <div
            className={`grid ${cols}   ${
                isBorder ? 'border-b border-borderUnderline' : ' '
            }  ${className} ${headerClassName} `}
        >
            {children}
        </div>
    );
}

function TableRow({ children, isBorder = true, verticalPadding = 'py-3', rowClassName = '', ...props }) {
    const { cols, className } = useContext(TableContext);

    return (
        <div
            {...props}
            className={`grid ${cols}   ${
                isBorder ? 'border-b border-borderUnderline' : ' '
            }  ${className} ${verticalPadding} ${rowClassName} `}
        >
            {children}
        </div>
    );
}
Table.Description = TableDescription;
Table.Header = TableHeader;
Table.Row = TableRow;

export default Table;
